import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'grid-button-render',
  template:
    '<div class=\'{{(textBeforeButton != null || textAfterButton != null) ? "itemcode" : ""}} {{itemcodeType}}\'><p *ngIf="textBeforeButton != null">{{textBeforeButton}}</p><span><a class="btn_secondary {{renderStyle}}" (click)="onClick()">{{this.params.buttonText}}</a></span>' +
    '<p *ngIf="textAfterButton != null" style="margin-left:10px;">{{textAfterButton}}</p>' +
    '<div  *ngIf="this.badge.className != null" class="exc_relative"><span class="{{this.badge.className}}">{{params.badge.text}}</span></div>' +
    '</div>',
  styleUrls: ['./grid-button-render.component.css']
})
export class GridButtonRenderComponent implements ICellRendererAngularComp {
  public params: any;
  public textBeforeButton: String;
  public textAfterButton: String;
  public itemcodeType: String;
  public renderStyle: String;
  public badge = {
    className: null,
    text: null
  };
  constructor() { }
  agInit(params: any): void {
    this.params = params;
    if (params.itemFieldBeforeButton) this.textBeforeButton = this.params.data[params.itemFieldBeforeButton];
    if (params.itemFieldAfterButton) this.textAfterButton = this.params.data[params.itemFieldAfterButton];

    if (this.params.badge && this.params.badge.getClassName) {
      this.badge.className = this.params.badge.getClassName(this.params.node.data);
    }

    if (params.itemFieldAfterButton) this.itemcodeType = 'itemcode--right';
    if (params.itemFieldBeforeButton) this.itemcodeType = 'itemcode--left';

    if (params.buttonText === '在庫修正') {
      // console.log(this.params.data['itemCd']);
      //SW-2531対応 荷主ユーザーの場合在庫修正ボタンを押させない
      this.renderStyle = params.buttonStyle;
      //SWMS-1178対応　引当可能数=0の場合、ボタン非表示（在庫数だと引当済数も含まれているため、引当可能数=0でもボタンが押せてしまい、エラーメッセージが出る）
      if (Number(this.params.data['pstockNr']) === 0 || !this.params.data['itemCd'])
        this.renderStyle = 'dspnone';
    }

    if (params.buttonText === '詳細') {
      const loginResult = sessionStorage.getItem('loginResult');
      let user = JSON.parse(loginResult).user;
      if (user.roleId == 3)
        this.renderStyle = 'dspnone';
    }
  }

  onClick($event): void {
    if (this.params.onClick instanceof Function) this.params.onClick(this.params.node, event);
  }

  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/render/grid-button-render.component.ts